export default "__VITE_ASSET__CK0kPm9c__"